import { Upload, Progress, Form, message } from "antd";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import React from "react";

const UploadImageNew = props => {
  const { t } = useTranslation("dashboard");
  const [fileList, setFileList] = useState([]);
  const form = Form.useFormInstance();
  const [progress, setProgress] = useState(0);
  const { multiple, text = t("Upload Photo") } = props;

  useEffect(() => {
    if (form) {
      setTimeout(() => {
        if (multiple) {
          let oldImages = form.getFieldValue(props.name);
          if (oldImages && typeof oldImages == "string") oldImages = JSON.parse(oldImages);
          if (Array.isArray(oldImages)) {
            let arr = [];
            oldImages.map((item, index) => {
              arr.push({
                name: item,
                url: item,
                status: "done"
              });
            });
            setFileList(arr);
          }
        } else {
          const oldImage = form.getFieldValue(props.name);
          if (oldImage) {
            setFileList([
              {
                uid: "-1",
                name: oldImage,
                // url: process.env.REACT_APP_BACKEND_URL + `/${module}/` + oldImage,
                url: oldImage,
                status: "done"
              }
            ]);
          }
        }
      }, 1000);
    }
  }, [form]);

  const uploadImage = async options => {
    const { onSuccess, onError, file, onProgress } = options;

    const fmData = new FormData();
    fmData.append("file", file);

    try {
      const res = await fetch(process.env.REACT_APP_BACKEND_URL + "/files/upload", {
        method: "POST",
        body: fmData,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      });

      const data = await res.json();

      if (res.ok) {
        onSuccess && onSuccess({ name: data.fileName || data.url || data });
      } else {
        throw new Error(data.message || "Upload failed");
      }
    } catch (err) {
      onError && onError(err);
    }
  };

  const handleChange = ({ fileList: newFileList }) => {
    if (!multiple) {
      if (!(newFileList.length > 0)) {
        form.setFieldValue(props.name, "");
      } else {
        form.setFieldValue(props.name, newFileList[0]?.response?.name ?? newFileList[0]?.name);
      }
    } else {
      let arr = [];

      newFileList?.map((item, index) => {
        const isJpgOrPng = item.type === "image/jpeg" || item.type === "image/png";

        if (!isJpgOrPng) {
          newFileList[index].status = "error";
        }

        const isLt1M = item.size / 1024 / 1024 < 10;
        if (!isLt1M) {
          newFileList[index].status = "error";
        }
        arr.push(newFileList[index]?.response?.name ?? newFileList[index]?.name);
      });
      form.setFieldValue(props.name, arr);
    }
    setFileList(newFileList);
  };
  return (
    <>
      <Upload
        accept="image/*"
        customRequest={uploadImage}
        fileList={fileList}
        multiple
        // customRequest={uploadImage}
        beforeUpload={file => {
          const isJpgOrPng =
            file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/webp";

          if (!isJpgOrPng) {
            message.error(t("Only JPG, PNG or WebP images are allowed."));
          }

          const isLt1M = file.size / 1024 / 1024 < 10;
          if (!isLt1M) {
            message.error(t("Image size must be less than 10MB!"));
          }

          return isJpgOrPng && isLt1M;
        }}
        onChange={handleChange}
        listType="picture-card"
        className="image-upload-grid"
        maxCount={multiple ? 4 : 1}
        // onProgress={({ percent }) => {
        //   console.log("progre...", percent);
        //   if (percent === 100) {
        //     setTimeout(() => setProgress(0), 1000);
        //   }
        //   return setProgress(Math.floor(percent));
        // }}
      >
        {multiple ? (
          fileList.length >= 4 ? (
            ""
          ) : (
            <div>{text}</div>
          )
        ) : fileList.length > 0 ? (
          ""
        ) : (
          <div>{text}</div>
        )}
      </Upload>
      {progress > 0 ? <Progress percent={progress} /> : null}
    </>
  );
};

export default UploadImageNew;
